module.exports = __webpack_public_path__ + "community_3.d80e889e2d595b2ac6df04e31b617134.jpg";